import { useEffect, useState } from "react";
import { GlobalStyle, Container, Logo } from "../../../../common"
import { Load } from "../../../../common/load/load";
import { SessionModel } from "../../applications/domain/session";
import { sessionState } from "../../applications/state/session-state";
import { useParams } from "react-router-dom";
import { SessionQrcode } from "./session-qrcode";
import { CreateSessionForm } from "./create-session-from";
import { SessionController } from "../../infra/controller/session.controller";
import { AuthRepository } from "../../../../common/auth-guard/auth.repository";
import { GetWorkoutUseCase } from "../../../workouts/application/usecases/get-workout.usecase";
import {
    DrillSessionQuota,
    resolveDrillQuota,
} from "../../../../common/session-quota/drill-session-quota";
import { isDrillSessionQuotaExceededError } from "../../applications/errors/drill-session-quota-exceeded.error";
import { SessionQuotaUpgrade } from "./session-quota-upgrade";

export const SessionConnectionsUi = () => {
    const { workoutId } = useParams<{ workoutId: string }>();
    const [session, setSession] = useState<SessionModel>(sessionState);
    const [load, setLoad] = useState<boolean>(false);
    const [quota, setQuota] = useState<DrillSessionQuota | null>(null);

    useEffect(() => {
        if (!workoutId) return;
        (async () => {
            try {
                setLoad(true);
                const [me, workout] = await Promise.all([
                    AuthRepository.me(),
                    GetWorkoutUseCase.execute(workoutId),
                ]);
                const drillQuota = resolveDrillQuota(me.planDuration, me.drills, workout.drillId);
                if (drillQuota.blocked) {
                    setQuota(drillQuota);
                    setLoad(false);
                    return;
                }
                const sessions = await SessionController.listSessions({
                    workoutId,
                    listReceiveMessage: true
                });
                setSession(sessions[0]);
                setLoad(false);
            } catch (error) {
                setLoad(false);
            }
        })();
    }, [workoutId]);

    const handleCreateSession = async (name: string, captureReactionTime: boolean) => {
        try {
            setLoad(true);
            const session = await SessionController.createSession({
                workoutId: workoutId ?? "",
                name,
                captureReactionTime,
            });
            await SessionController.listenReceiveMessage(session.id);
            setSession(session);
            setLoad(false);
        } catch (error) {
            if (isDrillSessionQuotaExceededError(error)) {
                setQuota({
                    drillId: error.drillId,
                    executionsUsed: error.executionsUsed,
                    executionsLimit: error.executionsLimit,
                    blocked: true,
                });
            }
            setLoad(false);
        }
    }

    return (
        <>
            <GlobalStyle />
            <Container>
                {load && <Load />}
                <Logo center={true} margintop="20px" marginbottom="20px" />
                {quota?.blocked ?
                    <SessionQuotaUpgrade
                        executionsUsed={quota.executionsUsed}
                        executionsLimit={quota.executionsLimit}
                    />
                    : session?.qrcode ?
                    <SessionQrcode
                        qrcode={session?.qrcode}
                        link={session?.link}
                        load={load}
                    />
                    : <CreateSessionForm
                        load={load}
                        onSubmit={handleCreateSession}
                    />
                }
            </Container>
        </>
    )
}
